import React from 'react';

export const Loader = (): JSX.Element => <div className="pageloader pageloader--full" />;
